export default "__VITE_ASSET__C5QXw1mD__"